module.exports = __webpack_public_path__ + "img/email-fill.4f0630d1.svg";